// extracted by css-extract-rspack-plugin
export default {"warningText":"R147Report__warningText--RTYDZ"};